import { render, staticRenderFns } from "./ManifestDataTable.template.vue?vue&type=template&id=1ef199ab&scoped=true&"
var script = {}
import style0 from "./ManifestDataTable.template.vue?vue&type=style&index=0&id=1ef199ab&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef199ab",
  null
  
)

export default component.exports